import { render } from "./ArticlesFilters.vue?vue&type=template&id=b45d51ea"
import script from "./ArticlesFilters.vue?vue&type=script&lang=js"
export * from "./ArticlesFilters.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/ArticlesFilters.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b45d51ea"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b45d51ea', __exports__)) {
    api.reload('b45d51ea', __exports__)
  }
  
  module.hot.accept("./ArticlesFilters.vue?vue&type=template&id=b45d51ea", () => {
    api.rerender('b45d51ea', render)
  })

}


export default __exports__